import {
    SET_COLUMN_FILTER_PARAMS,
    SET_TASK_LIST_FILTER_PARAMS,
    SET_LEAD_FILTER_PARAMS,
    SET_TASK_GRAPH_FILTER_PARAMS,
    SET_PROPOSAL_LIST_FILTER_PARAMS,
    SET_KPI_LIST_FILTER_PARAMS,
    RESET_ALL_FILTERS
} from "./types";

export const setLeadFilterParams = payload => dispatch => dispatch({type: SET_LEAD_FILTER_PARAMS, payload});
export const setColumnFilterParams = payload => dispatch => dispatch({type: SET_COLUMN_FILTER_PARAMS, payload});
export const setTaskListFilterParams = payload => dispatch => dispatch({type: SET_TASK_LIST_FILTER_PARAMS, payload});
export const setTaskGraphsFilterParams = payload => dispatch => dispatch({type: SET_TASK_GRAPH_FILTER_PARAMS, payload});
export const setProposalListFilterParams = payload => dispatch => dispatch({type: SET_PROPOSAL_LIST_FILTER_PARAMS, payload});
export const setKpiListFilterParams = payload => dispatch => dispatch({type: SET_KPI_LIST_FILTER_PARAMS, payload});
export const resetAllFilters = payload => dispatch => dispatch({type: RESET_ALL_FILTERS, payload});
